const {
  device,
  device: {
    Hybrid,
    Orientation,
    breakpoint,
    browser,
    hybrid,
    isTouchable,
    orientation,
    os,
    screen,
    type
  }
} = window.o_global;

export { Hybrid, Orientation, breakpoint, browser, device, hybrid, isTouchable, orientation, os, screen, type };
/*                               */
